const get = require('lodash/get')
const tools = require('../../tools/location-docs')

module.exports = (locationDoc) => {
  const location = tools.getLocation(locationDoc)
  const routeId = get(location, 'programs[0].services[0].routeId')
  return routeId
}
